import React from "react";

// External Package
import { useSelector } from "react-redux";

// State
import { RootState } from "../../store/authStore";

export default function ServiceHeaderComponents() {
  const isMobile = useSelector((state: RootState) => state.auth.isMobile);

  return (
    <div className="services_content_header">
      {isMobile ? (
        // Mobile View

        <div className="row">
          <div className="col-12">
            <div className="title font-size-14 font-vietnam-100 text-uppercase">
              advance website solution for landing page, blog, e-commerce, and
              more
            </div>
            <div className="mt-3">
              <h1 className="font-vietnam-600 font-size-60">[Digital</h1>
              <h1 className="font-vietnam-600 font-size-60 lh-1">Systems]</h1>
            </div>
            <div className="contact-us mt-5 mb-5">
              <a
                href="/contact"
                className="btn btn-contact rounded-0"
                rel="noreferrer"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      ) : (
        // Desktop View

        <div className="row">
          <div className="col-6">
            <div className="title font-size-14 font-vietnam-100 text-uppercase">
              advance website solution for landing page, blog, e-commerce, and
              more
            </div>
            <div className="mt-3">
              <h1 className="font-vietnam-600 font-size-130">[Digital</h1>
              <h1 className="font-vietnam-600 font-size-130 lh-1">Systems]</h1>
            </div>
            <div className="contact-us mt-5">
              <a
                href="/contact"
                className="btn btn-contact rounded-0"
                rel="noreferrer"
              >
                Contact Us
              </a>
            </div>
          </div>
          <div
            data-aos="fade-down-left"
            data-aos-anchor-placement="top-center"
            data-aos-duration={"500"}
            className="col-6 images-thumbnail"
          >
            <img
              src={require("../../assets/images/services/services_header.jpg")}
              alt="services"
              width={"100%"}
              loading="lazy"
            />
            <div className="experiences rounded-pill">
              <div className="number font-size-28 fw-bold">4+</div>
              <div className="font-vietnam-100-italic">Years Experiences</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
